import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoaderComponent implements OnInit, AfterViewInit {
  private static readonly MIN_TIME_TO_SHOW_LOADER = 500;

  private static hidden = false;
  public static actualScrollY: number;

  static show(callback = null) {
    try {
      this.hidden = false;
      this.actualScrollY = window.scrollY;
      setTimeout(() => {
        if (!this.hidden) {
          document.getElementById('innportingLoader').style.display = 'flex';
          document.body.classList.add('position-fixed');
          document.body.style.top = `-${this.actualScrollY}px`;
        }
        if (callback) {
          callback();
        }
      }, this.MIN_TIME_TO_SHOW_LOADER);
    } catch (e) {
      // Do nothing
    }
  }

  static hide() {
    try {
      this.hidden = true;
      document.body.classList.remove('position-fixed');
      document.body.style.removeProperty('top');
      window.scrollTo(0, this.actualScrollY);
      document.getElementById('innportingLoader').style.display = 'none';
    } catch (e) {
      // Do nothing
    }
  }

  ngAfterViewInit() {
    // ES module bundles can bootstrap after the document has become interactive.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => LoaderComponent.hide(), {once: true});
    } else {
      LoaderComponent.hide();
    }
  }

  ngOnInit() {
  }

}
